
import React from 'react';
import { Calendar, Filter, Plus } from 'lucide-react';

const Bookings: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Reservas de Pesca</h1>
          <p className="text-gray-500">Gerencie sua agenda e grupos de pesca.</p>
        </div>
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg font-bold flex items-center gap-2 hover:bg-blue-700">
          <Plus size={18} /> Nova Reserva
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center">
        <div className="mx-auto w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
          <Calendar size={32} className="text-blue-500" />
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">Nenhuma reserva encontrada</h3>
        <p className="text-gray-500 max-w-sm mx-auto mb-6">
          Comece adicionando uma nova reserva manualmente ou aguarde os pedidos pelo site.
        </p>
        <button className="text-blue-600 font-medium hover:underline">
          Ver calendário completo
        </button>
      </div>
    </div>
  );
};

export default Bookings;
